module.exports = __webpack_public_path__ + "static/media/transparentes.1c77012b.jpg";